import { useUnifiedBilling } from '../store/global-billing'
import { hasAvailablePerk, useMigrationOffer, type StoredHl1MigrationOffer } from './use-migration-offer'

export interface EffectiveBillingPlan {
  /** The plan to present in the UI (may differ from the billed plan, see below). */
  plan: string | undefined
  /** True when a pro/pro-trial (incl. EAT) user is presented as being on the v2 trial. */
  isPresentedAsV2Trial: boolean
}

/**
 * The plan to present in the UI. Pro and pro-trial users present as being on
 * the v2 trial (`pro2-trial`) so they're invited to pick one of the v2 tiers.
 * EAT users are covered too: the server already reports them as `pro-trial`. A
 * 1.0 user with the welcome-back trial still on offer sees their real plan instead, so
 * the offer is what invites them. Billing behavior is unaffected. This only
 * drives labels and CTAs.
 */
export function effectiveBillingPlan(
  rawPlan: string | undefined,
  offer: StoredHl1MigrationOffer | null,
): EffectiveBillingPlan {
  const isPresentedAsV2Trial = !hasAvailablePerk(offer) && (rawPlan === 'pro' || rawPlan === 'pro-trial')

  return {
    plan: isPresentedAsV2Trial ? 'pro2-trial' : rawPlan,
    isPresentedAsV2Trial,
  }
}

export function useEffectiveBillingPlan(): EffectiveBillingPlan {
  const { subscription } = useUnifiedBilling()
  const offer = useMigrationOffer()

  return effectiveBillingPlan(subscription.plan, offer)
}
